import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import { useMotiveDesktopStyles } from './styles';
import { validateProductByMotive } from '../../../../../../redux/actions/TicketActions';
import useExecuteScroll from '../../../../../../hooks/useExecuteScroll/useExecuteScroll';

const MotiveDesktop = ({ ...props }) => {
  const {
    children,
    haveValidation,
    title,
    motiveId,
    openMotive,
    setOpenMotive,
  } = props;
  const classes = useMotiveDesktopStyles();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded) executeScroll();
    setExpanded(isExpanded ? panel : false);
  };

  const { product } = children.props;

  const accordionRef = useRef(null);
  const executeScroll = () => useExecuteScroll(accordionRef);

  useEffect(() => {
    if ('panel1' == expanded) {
      setOpenMotive(motiveId);
      if (haveValidation)
        dispatch(
          validateProductByMotive(children.props.motiveId, {
            description: product.name,
            order_id: String(product.orderId),
            sale_date: product.purchaseDate,
            shipped_date: ' ',
            sku: product.sku,
            status: ' ',
            type: ' ',
          }),
        );
    }
  }, [expanded]);

  useEffect(() => {
    if (openMotive !== motiveId) setExpanded(false);
  }, [openMotive]);

  return (
    <Box width="100%">
      <Accordion
        onChange={handleChange('panel1')}
        expanded={'panel1' == expanded}
        elevation={0}
        className={classes.accordion}
      >
        <AccordionSummary
          ref={accordionRef}
          expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
        >
          <Typography className={classes.title}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
      <Divider />
    </Box>
  );
};

MotiveDesktop.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  motiveId: PropTypes.string,
  openMotive: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setOpenMotive: PropTypes.func,
  haveValidation: PropTypes.bool,
};

export default MotiveDesktop;
